/**
 * The per-staff "Hide staff who aren't working" key is `<prefix><stylistID>`.
 * Kept apart from AllStaffDisplaySettingsService so UserService can keep the
 * key through log-out without importing a service that injects it.
 */
export const HIDE_OFF_STAFF_KEY_PREFIX = 'allStaffHideOffStaff:';
